import { IChartApi, LineSeries } from 'lightweight-charts';
import { observer } from 'mobx-react-lite';

import _ from 'lodash';
import { makeAutoObservable, runInAction } from 'mobx';
import { useRef } from 'react';
import { twMerge } from 'tailwind-merge';
import { StockIndexPriceResponse } from '../../../server/response/responseScheme';
import themeStore from '../../stores/themeStore';
import { apiClient } from '../../clientUtils/apiClient';
import { useMobxInstance } from '../../clientUtils/mobxUtil';
import StockChart, { StockChartRef } from '../chart/StockChart';
import ChangeValue from '../common/ChangeValue';

class ViewStore {
    data: StockIndexPriceResponse[] = [];

    constructor() {
        makeAutoObservable(this);
    }

    async fetch() {
        const response = await apiClient.stockIndex.public.getValuesInRange.$query({
            ticker: '_T10Y',
        });

        runInAction(() => {
            this.data = response;
        });
    }
}

const TreasuryBriefCard = observer(({ className }: { className?: string }) => {
    const viewStore = useMobxInstance(ViewStore);

    const chartRef = useRef<StockChartRef>(null);

    const onChartReady = async (chart: IChartApi) => {
        await viewStore.fetch();

        const series = chart.addSeries(LineSeries, {
            lineWidth: 2,
            priceScaleId: 'right',
            color: themeStore.colors.primary,
        });

        series.setData(
            _.map(viewStore.data, (value) => ({
                time: value.date,
                value: value.value,
            })),
        );

        chart.timeScale().setVisibleLogicalRange({
            from: viewStore.data.length - 80,
            to: viewStore.data.length,
        });
    };

    const lastPoint = _.nth(viewStore.data, -1);
    const prevPoint = _.nth(viewStore.data, -2);
    const bpChange = lastPoint?.value && prevPoint?.value ? lastPoint.value - prevPoint.value : 0;

    return (
        <div className={twMerge('flex grow flex-col', className)}>
            <div className="-mx-5">
                <StockChart ref={chartRef} onChartReady={onChartReady} />
            </div>
            <div className="mt-4">
                {lastPoint && (
                    <div className="text-base-content/80 flex flex-col text-xl">
                        <div className="">10년물 국채금리는</div>
                        <div className="mt-3">
                            <strong className="mr-2 text-3xl font-semibold">
                                {lastPoint.value?.toFixed(2)}%
                            </strong>
                            로
                        </div>
                        <div className="mt-3">
                            <ChangeValue
                                className="mr-2 text-3xl font-semibold"
                                value={bpChange}
                                sign={true}
                                round={2}
                                suffix="%포인트"
                            />
                            {bpChange > 0 ? '상승' : '하락'}했습니다.
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
});

export default TreasuryBriefCard;
